import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Consulting } from "./components/Beratung";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Analytics } from '@vercel/analytics/react';
import { Leistungen } from "./components/Leistungen";
import Impressum from "./components/Impressum";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <NavBar />
        <Banner />
        <Skills />
        <Leistungen />
        <Consulting />
        <About />
        <Contact />

        <Routes>
          <Route path="/impressum" element={<Impressum />} />
        </Routes>

        <Footer />
        <Analytics />
      </div>
    </BrowserRouter>
  );
}

export default App;
